import React, {useEffect, useRef, useState} from 'react';
import { useDispatch } from 'react-redux';
import moment from "moment";
import "moment-lunar";
import dayjs from "dayjs";
import {alertService} from '@app/services/alertService';
import {myService} from '@app/services/thanhgiaoService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {HRTag, Tabs} from "@components";
import {
    root_path, INIT_ROLE_MENU, thanhgiao_METHOD
} from "@app/const/AppSetting";
import TailieuEdit from '@app/pages/FMasterData/FThanhgiao/TailieuEdit';
import {useTranslation} from "react-i18next";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {findObjInArr} from "@app/utils/CommonFunctions";
import LoaibieumautailieuListComponent from '@app/pages/FUtil/LoaibieumautailieuListComponent';
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import {ClipLoader} from "react-spinners";
import ReactPlayer from "react-player";
import LoaithanhgiaoListComponent from "@pages/FUtil/LoaithanhgiaoListComponent";
import CoquanListComponent from "@pages/FUtil/CoquanListComponent";
import CoquanTGListComponent from "@pages/FUtil/CoquanTGListComponent";
import ThoiListComponent from "@pages/FUtil/ThoiListComponent";
import NhadanListComponent from "@pages/FUtil/NhadanListComponent";
import DaohuuAutocompleteComponent from "@pages/FUtil/DaohuuAutocompleteComponent";
import Editor from "@pages/FUtil/Editor";
import NewDatePicker from "@pages/FUtil/NewDatePicker";
import DatePicker from "react-datepicker";
import PhanquyenListComponent from "@pages/FUtil/PhanquyenListComponent";
import TiepdienListComponent from "@pages/FUtil/TiepdienListComponent";

function ThanhgiaoEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const [lunarDate, setLunarDate] = useState("");
    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    // Refs for scrollTo functionality
    const taiLieuRef = useRef(null);
    const thongTinRef = useRef(null);
    const phanQuyenRef = useRef(null);
    const audioRef = useRef(null);

    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);
    const [fileUploads, setFileUploads] = useState([]);

    // ScrollTo functions
    const scrollToThongtin = () => {
        thongTinRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToAudio = () => {
        audioRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToPhanQuyen = () => {
        phanQuyenRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToTaiLieu = () => {
        taiLieuRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const initial = {
        id: id || 0,
        loaithanhgiao_fk: null,
        ten : '',
        trangthai_fk: null,
        noi_dung:'',
        link_audio: '',
        ghi_chu_file:'',
        thoi_fk: null,
        ngay: '',
        ngayam: '',
        coquan_fk: null,
        tiepdien_fks: [],
        nhadan_fk: null,
        dienkyobj: null,
        apdung: 0,
        nhadan_fks: [],
        capcoquan_fks: [],
        all: false
    };

    const handleFileChange = (e) => {
        const files = e.target.files;

        if(files.length > 0)
        {
            setFileUploads(files);
            const target = {name: "ghi_chu_file", value:''};
            onChangeInput({target});
        }
        else
        {
            setFileUploads([])
            const target = {name: "ghi_chu_file", value:''};
            onChangeInput({target});
        }
    };

    const [obj, setObj] = useState({...initial});

    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;

        if (name === "ngay" && value) {
            const formattedDate = dayjs(value).format("YYYY-MM-DD");
            const lunar = moment(formattedDate).lunar().format("DD/MM/YYYY");
            setLunarDate(lunar);

            setObj((prevState) => ({
                ...prevState,
                ['ngayam']: moment(formattedDate).lunar().format("YYYY-MM-DD")
            }));
        }

        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));
        console.log("Obj:", obj);
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const chonNhadan = (position,e) => {
        const {name, value, checked} = e.target;
        let q;
        let mAll;
        if(position === -1)
        {
            q = obj.nhadan_fks.map(obj=> ({ ...obj, checked: checked })) ;
            mAll = checked;
        }
        else
        {
            q = obj.nhadan_fks;
            q[position]['checked']= checked;
            mAll = obj.all;
        }
        setObj((prevState) => ({
            ...prevState,
            nhadan_fks: q,
            all:mAll
        }));
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const chonCapcoqquan = (position,e) => {
        const {name, value, checked} = e.target;
        let q;
        let mAll;
        if(position === -1)
        {
            q = obj.capcoquan_fks.map(obj=> ({ ...obj, checked: checked })) ;
            mAll = checked;
        }
        else
        {
            q = obj.capcoquan_fks;
            q[position]['checked']= checked;
            mAll = obj.all;
        }
        setObj((prevState) => ({
            ...prevState,
            capcoquan_fks: q,
            all:mAll
        }));
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const createRs = async () => {
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                setObj(userX);
            });
        }
    };

    useEffect(async () => {
        if (obj.ngay) {
            const lunar = moment(obj.ngay).lunar().format("DD/MM/YYYY");
            setLunarDate(lunar);
        }
    },[obj.ngay]);

    useEffect(async () => {
        await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });

        await createRs();
    }, []);

    const saveClick = async () => {
        let data = obj;

        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }
        if(!data.loaithanhgiao_fk || data.loaithanhgiao_fk.length === 0)
        {
            alert('Vui lòng chọn loại thánh giáo');
            return;
        }

        isAddMode ?  await createUser(data) : update(data);
    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    const downloadFile = async (id) => {
        try {
            const response = await myService.downloadFile(id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            console.log(response.data);
            console.log("Content-Disposition Header:", contentDisposition);
            let fileName = 'downloaded_file';
            if (contentDisposition) {
                console.log('header: '+contentDisposition);
                const matches = /filename\*=(?:UTF-8'')?([^;\n]+)/.exec(contentDisposition) || /filename="([^"]+)"/.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
                }
            }
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
            alert('Có lỗi xảy ra khi tải file.');
        }
    };

    async function createUser(data) {
        setLoading(true);
        let result;
        if(fileUploads && fileUploads.length > 0)
            result = await myService.Create2(fileUploads,data);
        else
            result = await myService.Create(data);

        if (result.status ==="1") {
            alertService.success(result.msg);
            isAddMode = false;
            id =result.data2;
            history.push('/'+currController+'/edit/'+id);
            await createRs();
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    async function update(data) {
        setLoading(true);
        console.log(data);
        const result = await myService.Update(id,data);

        if (result.status ==="1") {
            alertService.success(result.msg);
            history.push('/'+currController+'/edit/'+id);
            await createRs();
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
                className="btn btn-success mr-1"
                icon="right fas fa-angle-left"
                onClick={saveClick}
            >
                <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"} </i>
            </Button>
        );
    }

    // CSS Styles
    const formLabelStyle = {
        fontWeight: '500',
        color: '#495057',
        marginBottom: '5px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    };

    const formControlStyle = {
        border: '1px solid #ced4da',
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff'
    };

    const iconStyle = {
        fontSize: '14px',
        marginRight: '8px'
    };

    const lunarDateStyle = {
        marginTop: '5px',
        fontSize: '14px',
        fontWeight: '500'
    };

    return (
        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                {/* Navigation buttons - Fixed on right side */}
                { !isAddMode && (
                    <div style={{
                        position: 'fixed',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '1000',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToThongtin}
                        >
                            Thông tin chung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToAudio}
                        >
                            Audio & Nội dung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToPhanQuyen}
                        >
                            Phân quyền
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToTaiLieu}
                        >
                            Tài liệu
                        </button>
                    </div>
                )}

                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>

                <div className="tab-pane fade show active" id="thongtinnhanvien">
                    <div className="card-body" ref={thongTinRef}>
                        <HRTag title="Thông tin thánh giáo" />

                        {/* Row 1: Tên (chỉ hiện khi edit) */}
                        {!isAddMode && (
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-heading text-primary" style={iconStyle}></i>
                                        Tên thánh giáo
                                    </label>
                                    <input
                                        type='text'
                                        className="form-control"
                                        style={formControlStyle}
                                        name="ten"
                                        id="ten"
                                        value={obj.ten}
                                        onChange={(e) => onChangeInput(e)}
                                        placeholder="Nhập tên thánh giáo"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Row 2: Loại thánh giáo, Thời, Ngày */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <LoaithanhgiaoListComponent
                                    required="required"
                                    loaithanhgiao_fk={obj.loaithanhgiao_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "loaithanhgiao_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                            <div className="col-md-3">
                                <ThoiListComponent
                                    required="required"
                                    thoi_fk={obj.thoi_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "thoi_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                            <div className="col-md-3">
                                <label style={{...formLabelStyle, fontWeight: '600'}}>
                                    <i className="fas fa-calendar-alt text-warning" style={iconStyle}></i>
                                    Chọn Ngày Dương <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <NewDatePicker
                                    required="required"
                                    className="form-control w-100"
                                    isV2
                                    id="ngay"
                                    name="ngay"
                                    value={obj.ngay}
                                    onDayChange={onChangeInput}
                                />
                                <div style={lunarDateStyle}>
                                    <i className="fas fa-moon text-info" style={{marginRight: '5px'}}></i>
                                    Ngày Âm: <span style={{ color: "red" }}>{lunarDate}</span>
                                </div>
                            </div>
                        </div>

                        {/* Row 3: Thông tin đặc biệt cho loại 1 */}
                        {obj.loaithanhgiao_fk === 1 && (
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <CoquanTGListComponent
                                        coquan_fk={obj.coquan_fk}
                                        onChange={(opt, e) => {
                                            const target = {name: "coquan_fk", value: opt?.value};
                                            onChangeInput({target});
                                        }}
                                        filterIds={[1,2]}
                                        coquanName="label"
                                        labelname="Cấp thánh giáo"
                                        required="required"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <TiepdienListComponent
                                        isMulti={true}
                                        tiepdien_fks={obj.tiepdien_fks}
                                        onChange={(opt, e) => {
                                            const target = {name: "tiepdien_fks", value: opt};
                                            onChangeInput({target});
                                        }}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <NhadanListComponent
                                        required="required"
                                        nhadan_fk={obj.nhadan_fk}
                                        onChange={(opt, e) => {
                                            const target = {name: "nhadan_fk", value: opt?.value};
                                            onChangeInput({target});
                                        }}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label style={{...formLabelStyle, fontWeight: '600'}}>
                                        <i className="fas fa-user-edit text-success" style={iconStyle}></i>
                                        Điển ký <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                    </label>
                                    <DaohuuAutocompleteComponent
                                        path_access={currController}
                                        currentSuggestion={obj.dienkyobj}
                                        onChange={(e) => onChangeInput({ target: { name: 'dienkyobj', value: e?.value } })}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Audio & Nội dung Section */}
                        <div ref={audioRef}>
                            <HRTag title="Nội dung & Audio" />

                            {/* Row 4: Nội dung */}
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-file-alt text-info" style={iconStyle}></i>
                                        Nội dung
                                    </label>
                                    <Editor
                                        name="noi_dung"
                                        value={obj.noi_dung}
                                        onChange={onChangeInput}
                                        readonly={isDisplay ? "readonly" : ""}
                                    />
                                </div>
                            </div>

                            {/* Row 5: Link Audio */}
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-music text-success" style={iconStyle}></i>
                                        Link file audio
                                    </label>
                                    <input
                                        type='text'
                                        className="form-control"
                                        style={formControlStyle}
                                        name="link_audio"
                                        id="link_audio"
                                        value={obj.link_audio}
                                        onChange={(e) => onChangeInput(e)}
                                        placeholder="Nhập link file audio"
                                    />
                                </div>
                            </div>

                            {/* Row 6: Upload files (Add mode only) */}
                            {isAddMode && (
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label style={formLabelStyle}>
                                            <i className="fas fa-upload text-primary" style={iconStyle}></i>
                                            Tài liệu đính kèm
                                        </label>
                                        <input
                                            id='fileUploads'
                                            name="fileUploads"
                                            type="file"
                                            multiple
                                            accept="*"
                                            className="form-control"
                                            style={formControlStyle}
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                    {fileUploads && fileUploads.length > 0 && (
                                        <div className="col-md-6">
                                            <label style={formLabelStyle}>
                                                <i className="fas fa-sticky-note text-warning" style={iconStyle}></i>
                                                Ghi chú tài liệu
                                            </label>
                                            <input
                                                type='text'
                                                className="form-control"
                                                style={formControlStyle}
                                                name="ghi_chu_file"
                                                id="ghi_chu_file"
                                                value={obj.ghi_chu_file}
                                                onChange={(e) => onChangeInput(e)}
                                                placeholder="Nhập ghi chú cho tài liệu"
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Phân quyền Section */}
                        <div ref={phanQuyenRef}>
                            {!isAddMode && (
                                <>
                                    <HRTag title="Cài đặt phân quyền" />

                                    {/* Row 7: Trạng thái và Áp dụng cho */}
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <TrangthaiListComponent
                                                trangthai_fk={obj.trangthai_fk}
                                                onChange={(opt, e) => {
                                                    const target = {name: "trangthai_fk", value: opt?.value};
                                                    onChangeInput({target});
                                                }}
                                                filterIds={[0,1]}
                                                trangthaiName="name"
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label style={formLabelStyle}>
                                                <i className="fas fa-users-cog text-primary" style={iconStyle}></i>
                                                Áp dụng cho:
                                            </label>
                                            <select
                                                className="form-control"
                                                style={formControlStyle}
                                                value={obj.apdung}
                                                name="apdung"
                                                onChange={(e) => onChangeInput({ target: { name: e.target.name, value: parseInt(e.target.value, 10) } })}
                                            >
                                                <option value="0">Public: Tất cả thấy</option>
                                                <option value="1">Chọn nhà đàn được phép (multi)</option>
                                                <option value="2">Chọn Cấp Cơ Quan (multi)</option>
                                                <option value="3">Kỷ niệm (không hiện trên app)</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* Tables for permissions */}
                                    {obj.apdung === 1 && (
                                        <div className="row mb-3">
                                            <div className="col-md-12">
                                                <HRTag title="Phân quyền nhà đàn được thấy thánh giáo" />
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover text-nowrap">
                                                        <thead>
                                                        <tr>
                                                            <th className="col-md-1 text-center">ID</th>
                                                            <th className="col-md-1 text-center">Tên</th>
                                                            <th className="col-md-1 text-center">
                                                                Chọn
                                                                <input
                                                                    type="checkbox"
                                                                    id="custom-checkbox-all"
                                                                    value={obj.all}
                                                                    checked={obj.all}
                                                                    onChange={(e) => chonNhadan(-1,e)}
                                                                    style={{marginLeft: '5px'}}
                                                                />
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {obj.nhadan_fks && obj.nhadan_fks.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.value}</td>
                                                                <td>{item.label}</td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`custom-checkbox-${index}`}
                                                                        value={item.checked}
                                                                        checked={obj.nhadan_fks[index]?.checked}
                                                                        onChange={(e) => chonNhadan(index,e)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {obj.apdung === 2 && (
                                        <div className="row mb-3">
                                            <div className="col-md-12">
                                                <HRTag title="Phân quyền cấp cơ quan được thấy thánh giáo" />
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover text-nowrap">
                                                        <thead>
                                                        <tr>
                                                            <th className="col-md-1 text-center">ID</th>
                                                            <th className="col-md-1 text-center">Tên</th>
                                                            <th className="col-md-1 text-center">
                                                                Chọn
                                                                <input
                                                                    type="checkbox"
                                                                    id="custom-checkbox-all-cq"
                                                                    value={obj.all}
                                                                    checked={obj.all}
                                                                    onChange={(e) => chonCapcoqquan(-1,e)}
                                                                    style={{marginLeft: '5px'}}
                                                                />
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {obj.capcoquan_fks && obj.capcoquan_fks.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.value}</td>
                                                                <td>{item.label}</td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`custom-checkbox-cq-${index}`}
                                                                        value={item.checked}
                                                                        checked={obj.capcoquan_fks[index]?.checked}
                                                                        onChange={(e) => chonCapcoqquan(index,e)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        {/* Tài liệu Section */}
                        {!isAddMode && (
                            <div ref={taiLieuRef}>
                                <HRTag title="Tài liệu đính kèm" />
                                <TailieuEdit id={id} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="card-footer">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>
        </div>
    );
}

export {ThanhgiaoEdit};